import React, { useMemo, useState } from 'react';
import { Tabs } from '@spark';

import SettingsSectionCard from '@/features/settings/components/SettingsSectionCard.jsx';
import EcrCredentialsForm from './EcrCredentialsForm.jsx';
import DockerHubCredentialsForm from './DockerHubCredentialsForm.jsx';
import GcrCredentialsForm from './GcrCredentialsForm.jsx';
import AcrCredentialsForm from './AcrCredentialsForm.jsx';
import '../settings.css';

const REGISTRY_TABS = [
    { id: 'dockerhub', label: 'Docker Hub', targetsField: 'dockerhub_targets' },
    { id: 'ecr', label: 'AWS - ECR', targetsField: 'aws_ecr_targets' },
    { id: 'gcr', label: 'GCP - GCR', targetsField: 'gcp_gcr_targets' },
    { id: 'acr', label: 'Azure - ACR', targetsField: 'azure_acr_targets' },
];

const savedTargetCount = (settings, targetsField) =>
    Array.isArray(settings?.[targetsField]) ? settings[targetsField].length : 0;

/**
 * External Deploy - Targets tab (Figma frame 6026-722): description, a
 * horizontal registry Tabs row (Docker Hub / AWS - ECR / GCP - GCR /
 * Azure - ACR), then the registry panel 20px below.
 */
const ExternalDeployTargetsForm = ({
    settings,
    onEcrSettingsUpdate,
    onDockerHubSettingsUpdate,
    onGcrSettingsUpdate,
    onAcrSettingsUpdate,
}) => {
    const [registry, setRegistry] = useState('dockerhub');

    // Tab labels carry the saved-target count per registry, mirroring the
    // "(n)" key counts on the Model Providers tabs.
    const tabItems = useMemo(
        () =>
            REGISTRY_TABS.map(({ id, label, targetsField }) => ({
                id,
                label: `${label} (${savedTargetCount(settings, targetsField)})`,
            })),
        [settings]
    );

    return (
        <SettingsSectionCard iconSlug="external-deploy" title="External Deploy - Targets">
            <p className="settings-text settings-providers__description fs-unmask">
                Choose a registry, then configure credentials and named push
                targets. Operators select a target by alias in the model
                download flow — they never type a raw repository URI.
            </p>

            <div className="settings-providers fs-unmask">
                <Tabs
                    items={tabItems}
                    activeId={registry}
                    onChange={setRegistry}
                    size="large"
                    position="top"
                />

                {registry === 'dockerhub' ? (
                    <DockerHubCredentialsForm
                        settings={settings}
                        onDockerHubSettingsUpdate={onDockerHubSettingsUpdate}
                    />
                ) : null}

                {registry === 'ecr' ? (
                    <EcrCredentialsForm
                        settings={settings}
                        onEcrSettingsUpdate={onEcrSettingsUpdate}
                    />
                ) : null}

                {registry === 'gcr' ? (
                    <GcrCredentialsForm
                        settings={settings}
                        onGcrSettingsUpdate={onGcrSettingsUpdate}
                    />
                ) : null}

                {registry === 'acr' ? (
                    <AcrCredentialsForm
                        settings={settings}
                        onAcrSettingsUpdate={onAcrSettingsUpdate}
                    />
                ) : null}
            </div>
        </SettingsSectionCard>
    );
};

export default ExternalDeployTargetsForm;
